<div class="container-fluid m-0 p-0" *ngIf="!showLoader">

    <form [formGroup]="section1Data" (change)="section1DataChange()" (submit)="section1DataSubmit()">



        <div class="row bg-white page-head p-3 d-flex flex-wrap justify-content-between">
            <div class="col-md-6 d-flex align-self-center justify-content-center justify-content-lg-start">
                <h6 class="font-bold m-0">{{"SECTION_2_TITLE" | translate | titlecase }}</h6>
            </div>

            <div class="col-md-6 d-flex flex-wrap justify-content-center justify-content-lg-end">
                <button type="reset" class="btn btn-outline-secondary m-2 rounded-0">
                    {{"RESET" | translate | titlecase }}</button>
                <button type="submit" class="btn btn-primary m-2 rounded-0" *ngIf="!creating"><i class="fas fa"></i>
                    {{"NEXT" | translate | titlecase }}</button>
                <app-loader [show]="creating"></app-loader>
            </div>



        </div>
        <div class="row mt-4">

            <div class="col-12">

                <div class="row bg-white border m-0 py-3">
                    <div class="col-md-10 mx-md-auto py-3">
                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"CANDUDATE_CODE" | translate | titlecase }}</label>
                                <input type="text" class="form-control" value="Candidate CODE"
                                    formControlName="candCode" readonly>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">


                                <label class="font-bold">{{"LIVE_WITH" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="liveWith"
                                    (change)="liveWith()">
                                    <option value="" [selected]="true">{{ "SELECT" | translate | titlecase }}</option>
                                    <option *ngFor="let res of livewith" [ngValue]="res.id">{{
                                        (globals.lang == 'ar')? res.livewithNameAr : res.livewithNameEn
                                        }}</option>

                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="section1Data.controls.liveWith.touched && section1Data.controls.liveWith.invalid && section1Data.dirty">
                                    {{"PLEASE_SELECT_LIVE_WITH" | translate | titlecase }}
                                </div>
                            </div>
                        </div>

                        <div class="row" *ngIf="selectOther">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"LIVE_WITH_OTHER" | translate | titlecase }} </label>
                                <input type="text" class="form-control" placeholder="Live With Other"
                                    formControlName="liveWithOther">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="section1Data.controls.liveWithOther.touched && section1Data.controls.liveWithOther.invalid && section1Data.dirty">
                                    {{"PLEASE_ENTER_AVAILD_LIVE_WITH" | translate | titlecase }}
                                </div>
                            </div>
                        </div>


                        <div class="row" *ngIf="selectOther ||selectBoth||selectOne||selectGrand">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold" *ngIf="selectOther">{{"LIVE_WITH_MOBILE_1" | translate | titlecase }}</label>
                                <label class="font-bold" *ngIf="selectBoth||selectOne">{{"FATHER_MOBILE" | translate | titlecase }}</label>
                                <label class="font-bold" *ngIf="selectGrand">{{"GFATHER_MOBILE" | translate | titlecase }}</label>
                                <input type="text" class="form-control" placeholder="Live With Mobile 1"
                                    formControlName="liveWithMobile1">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="section1Data.controls.liveWithMobile1.touched && section1Data.controls.liveWithMobile1.invalid && section1Data.dirty">
                                    {{"PLEASE_SELECT_AVAILD_MOBILE" | translate | titlecase }}
                                </div>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="section1Data.hasError('reqPhone') && section1Data.controls.liveWithMobile1.value.length==0">
                                    {{"PLEASE_SELECT_AVAILD_MOBILE" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold" *ngIf="selectOther">{{"LIVE_WITH_MOBILE_2" | translate | titlecase }}</label>
                                <label class="font-bold" *ngIf="selectBoth||selectOne">{{"MOTHER_MOBILE" | translate | titlecase }}</label>
                                <label class="font-bold" *ngIf="selectGrand">{{"GMOTHER_MOBILE" | translate | titlecase }}</label>
                                <input type="text" class="form-control" placeholder="Live With Mobile 2"
                                    formControlName="liveWithMobile2">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="section1Data.controls.liveWithMobile2.touched && section1Data.controls.liveWithMobile2.invalid && section1Data.dirty">
                                    {{"PLEASE_SELECT_AVAILD_MOBILE" | translate | titlecase }}
                                </div>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="section1Data.hasError('reqPhone')&& section1Data.controls.liveWithMobile2.value.length==0">
                                    {{"PLEASE_SELECT_AVAILD_MOBILE" | translate | titlecase }}
                                </div>
                            </div>
                        </div>

                        <!-- <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"LIVE_WITH_CONTACT_1" | translate | titlecase }} </label>
                                <input type="text" class="form-control" placeholder="Live With Contact 1"
                                    formControlName="liveWithContact1">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="section1Data.controls.liveWithContact1.touched && section1Data.controls.liveWithContact1.invalid && section1Data.dirty">
                                    {{"PLEASE_ENTER_AVAILD_CONTACT" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"LIVE_WITH_CONTACT_2" | translate | titlecase }}</label>
                                <input type="text" class="form-control" placeholder="Live With Contact 2"
                                    formControlName="liveWithContact2">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="section1Data.controls.liveWithContact2.touched && section1Data.controls.liveWithContact2.invalid && section1Data.dirty">
                                    {{"PLEASE_ENTER_AVAILD_CONTACT" | translate | titlecase }}
                                </div>
                            </div>
                        </div> -->


                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"SIBLINGS_COUNT" | translate | titlecase }}</label>
                                <input type="number" class="form-control" placeholder="Siblings Count"
                                    formControlName="siblingsCount">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="section1Data.controls.siblingsCount.touched && section1Data.controls.siblingsCount.invalid && section1Data.dirty">
                                    {{"PLEASE_ENTER_AVAILD_SIBLINGS_COUNT" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"CAND_SIBLINGS_RANK" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="candSiblingsRank">
                                    <option value="" [selected]="true">{{"SELECT" | translate | titlecase }}</option>
                                    <option *ngFor='let in of candidateOrderINFamily ;let i = index'>{{i+1}}</option>
                                    <!-- <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option> -->

                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="section1Data.controls.candSiblingsRank.touched && section1Data.controls.candSiblingsRank.invalid && section1Data.dirty">
                                    {{"PLEASE_SELECT_CAND_SINLINGS_RANK" | translate | titlecase }}
                                </div>
                            </div>
                        </div>


                        <div class="row" *ngFor="let question of questionData">
                            <div class="col-md-12 form-group px-md-5 mb-4">
                                <label class="font-bold">
                                    {{
                                    (globals.lang == 'ar')? question.questionDescAr : question.questionDescEn
                                    }}</label>
                                <input type="text" class="form-control" placeholder="{{
                                    (globals.lang == 'ar')? question.questionDescAr : question.questionDescEn
                                    }}" formControlName="{{  question.formControlName}}"
                                    *ngIf="question.questionType == 'TEXT'">
                                <select class="form-control custom-select"
                                    *ngIf="question.questionType == 'LIST' && question.values.length > 0"
                                    formControlName="{{  question.formControlName}}">
                                    <option value="" [selected]="true">{{"SELECT" | translate | titlecase }}</option>
                                    <option [ngValue]="(globals.lang == 'ar')? value.valueDescAr : value.valueDescEn"
                                        *ngFor="let value of question.values">{{
                                        (globals.lang == 'ar')? value.valueDescAr : value.valueDescEn
                                        }}</option>

                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="isTouched(question.formControlName) && isInvalid(question.formControlName) && section1Data.dirty">
                                    {{"THIS_QUESTION_IS_REQUIRED" | translate | titlecase }}
                                </div>
                                <!-- <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="section1Data.controls.siblingsCount.touched && section1Data.controls.siblingsCount.invalid && section1Data.dirty">
                                    Please enter a valid Siblings Count
                                </div> -->
                            </div>

                        </div>




                    </div>

         
                        <div class="col-md-12 d-flex flex-wrap justify-content-center justify-content-lg-end">
                            <button type="reset" class="btn btn-outline-secondary m-2 rounded-0">
                                {{"RESET" | translate | titlecase }}</button>
                            <button type="submit" class="btn btn-primary m-2 rounded-0" *ngIf="!creating"><i class="fas fa"></i>
                                {{"NEXT" | translate | titlecase }}</button>
                            <app-loader [show]="creating"></app-loader>
                        </div>
            
            
            
                </div>
            </div>
        </div>



    </form>
</div>

<app-loader [attr.show]="showLoader"></app-loader>